import { render, staticRenderFns } from "./purchaseStat_h.vue?vue&type=template&id=22145e12&"
import script from "./purchaseStat_h.vue?vue&type=script&lang=js&"
export * from "./purchaseStat_h.vue?vue&type=script&lang=js&"
import style0 from "./purchaseStat_h.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "purchaseStat_h.vue"
export default component.exports